import { authorizedFetch } from '../helpers/http.js';

// Resolves the current portal URL the same way CompanyService does, so endpoints
// that still derive the tenant slug from it can do so.
function currentUrl() {
  const url = window.location.href;
  return url.replace('/career/#/', '/').replace('/#/', '/');
}

function withUrlParam(path) {
  const separator = path.includes('?') ? '&' : '?';
  return `${path}${separator}url=${encodeURIComponent(currentUrl())}`;
}

export default {
  getApplications() {
    return authorizedFetch(withUrlParam('/candidate/applications'));
  },

  // Cancels one of the candidate's applications (status → denied by candidate).
  // Candidate + tenant are taken from the token, so no url is needed.
  cancelApplication(applicationId) {
    return authorizedFetch(`/candidate/applications/${applicationId}/cancel`, {
      method: 'POST'
    });
  },

  // Sends a message to the contact person of the application's joboffer.
  // Candidate + tenant are taken from the token, so no url is needed.
  contactRecruiter(applicationId, message) {
    return authorizedFetch('/candidate/applications/contact', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ applicationId, message })
    });
  },

  // Profile endpoints take the candidate + tenant from the token, so no url.
  getProfile() {
    return authorizedFetch('/candidate/profile');
  },

  updateProfile(profile) {
    return authorizedFetch('/candidate/profile', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(profile)
    });
  },

  // Deletes the signed-in candidate's profile and all their applications. The
  // candidate + tenant are taken from the token, so no url is needed.
  deleteProfile() {
    return authorizedFetch('/candidate/profile', {
      method: 'DELETE'
    });
  },

  // Persists the candidate's document set (kept existing ids + newly uploaded
  // temp files). Returns the updated document list.
  updateDocuments(payload) {
    return authorizedFetch('/candidate/documents', {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    });
  },

  // Whether the candidate has two-factor authentication (an OTP credential) on.
  getTwoFactorStatus() {
    return authorizedFetch('/candidate/2fa');
  },

  // Disables two-factor authentication by removing the OTP credential(s).
  disableTwoFactor() {
    return authorizedFetch('/candidate/2fa', {
      method: 'DELETE'
    });
  },

  // Copies a stored document into the temporary bucket and returns a file
  // reference that can be attached to a new application.
  reuseDocument(documentId) {
    return authorizedFetch(`/candidate/documents/${documentId}/reuse`, {
      method: 'POST'
    });
  },

  // Anonymous registration during the application process. Sends the tenant slug
  // via the url so the account is created in the right company.
  register(payload) {
    return authorizedFetch('/candidate/register', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ ...payload, url: currentUrl() })
    });
  },

  // Anonymous email confirmation. Sends the raw token from the link plus the
  // tenant slug (via the url) so the right company's account is confirmed.
  confirm(token) {
    return authorizedFetch('/candidate/confirm', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ token, url: currentUrl() })
    });
  }
};
